module.exports = __webpack_public_path__ + "static/assets/ad218339ca42519f314d17dba03dff83.png";